import api from "api";
import { FilterField, SiteListingProps } from "pages/Site/pages/type";
import React, { useEffect, useState, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { TableMapping } from "shared/components/Table/type";
import { fromNow } from "utils/DateUtils";
import SiteListingFilter from "../components/SiteListingFilter";
import SiteListingPagination from "../components/SiteListingPagination";
import SiteListingTable from "../components/SiteListingTable";
import "../../../styles/sitelisting.scss";
import { SelectItem } from "shared/components/Input/type";
import _ from "lodash";
import CreateNewSiteModal from "pages/Site/components/CreateNewSiteModal";
import { Row } from "reactstrap";
import { SiteStatistic } from "Models/site";
import SiteStatisticItem from "pages/Site/components/SiteStatisticItem";
import Loading from "components/Loading";
import t from "utils/Lang";

const SiteName = ({ site }: { site: any }) => {
  return (
    <div className="site-name-container">
      <img className="img-brand" src={site.brand?.brand_logo_image} />
      <span className="site-name">{site?.name || "Chưa có tên"}</span>
    </div>
  );
};

const tableMapping: Array<TableMapping> = [
  {
    label: t().site_listing__site_name,
    mappingKeys: ["name"],
    defaultVal: "Chưa có tên",
    customComponent: (site: any) => <SiteName site={site} />,
    isActive: true,
    isFiltered: false,
    id: "0",
    filterKey: "name",
  },
  {
    id: "1",
    label: t().site_listing__status,
    mappingKeys: ["status", "name"],
    defaultVal: null,
    customComponent: null,
    isActive: true,
    isFiltered: null,
  },
  {
    id: "2",
    label: t().site_listing__address,
    mappingKeys: ["full_address"],
    defaultVal: null,
    customComponent: null,
    isActive: true,
    isFiltered: null,
  },
  {
    id: "3",
    label: t().site_listing__assignee,
    mappingKeys: [],
    defaultVal: null,
    customComponent: (site: any) => (
      <span>
        {site?.assignees
          ?.map(
            (assignee: any) => `${assignee.first_name} ${assignee.last_name}`
          )
          ?.join(",")}
      </span>
    ),
    isActive: true,
    isFiltered: null,
  },
  {
    id: "4",
    label: t().site_listing__city,
    mappingKeys: ["city", "name"],
    defaultVal: null,
    customComponent: null,
    isActive: true,
    isFiltered: null,
  },
  {
    id: "5",
    label: t().site_listing__created_by,
    mappingKeys: ["created_by"],
    defaultVal: null,
    customComponent: null,
    isActive: true,
    isFiltered: null,
  },
  {
    id: "6",
    label: t().site_listing__site_owner_reply_due_date,
    mappingKeys: ["contact_before_date"],
    defaultVal: null,
    customComponent: null,
    isActive: true,
    isFiltered: null,
  },
  {
    id: "7",
    label: t().site_listing__created_on,
    mappingKeys: ["created_on"],
    defaultVal: null,
    customComponent: (site: any) => <span>{fromNow(site?.created_on)}</span>,
    isActive: true,
    isFiltered: true,
    filterKey: "created_on",
  },
  {
    id: "8",
    label: t().site_listing__reverse_reason,
    mappingKeys: ["reason_rollback"],
    defaultVal: null,
    isActive: true,
  },
];

const initialSiteData = {
  sites: [],
  page: 1,
  totalPage: 0,
  limit: 10,
  loading: true,
  searchName: "",
  searchCity: [],
  tableMapping,
  searchAssignee: null,
  searchInternalCode: null,
};

const SiteListing = ({
  status,
  onChangeStatus,
  onSiteClick,
  siteStatistic,
  userBrand,
}: SiteListingProps) => {
  const [cityOptions, setCityOptions] = useState<Array<SelectItem>>([]);
  const [users, setUsers] = useState<Array<SelectItem>>([]);
  const [statusOptions, setStatusOptions] = useState<Array<SelectItem>>([]);
  const [siteData, setSiteData] = useState(initialSiteData);
  const [showCreateNewModal, setCreateNewModal] = useState<boolean>(false);
  const history = useHistory();
  const location = useLocation();
  const getSiteListing = async (
    newTableMapping?: Array<TableMapping>,
    searchName = siteData.searchName
  ) => {
    if (!status) return;
    const tableMapping = newTableMapping || siteData.tableMapping;
    const sortedField = tableMapping.find((row) => row.isFiltered);
    const orderBy = sortedField?.filterKey || "created_on";
    const orderDirection = sortedField ? "desc" : "asc";
    let uriParams = `page=${siteData.page - 1}&limit=${
      siteData.limit
    }&order_by=${orderBy}&order_direction=${orderDirection}`;
    if (searchName !== "") {
      uriParams = `${uriParams}&name=${searchName}`;
    }
    if (status !== "all") {
      uriParams = `${uriParams}&status_id=${status}`;
    }
    if (siteData?.searchAssignee && siteData?.searchAssignee != "all") {
      uriParams = `${uriParams}&assignee_id=${siteData.searchAssignee}`;
    }
    if (siteData?.searchInternalCode) {
      uriParams = `${uriParams}&internal_code=${siteData.searchInternalCode}`;
    }
    if (
      siteData.searchCity &&
      siteData.searchCity.length > 0 &&
      !siteData.searchCity.find((city: any) => city.value == "all")
    ) {
      uriParams = `${uriParams}&city_id=${siteData.searchCity
        .map((city: any) => city.value)
        .join(",")}`;
    }
    const res = await api.getSiteListing(uriParams);
    if (res?.result) {
      const columns = res?.site_column_show || [];
      setSiteData({
        ...siteData,
        sites: res?.result,
        totalPage: Math.ceil(res?.count / siteData?.limit),
        loading: false,
        tableMapping: tableMapping.map((el) => {
          if (columns.length > 0) {
            el.isActive = !!columns.find((c: any) => c === el.label);
          }
          return el;
        }),
        searchName,
      });
    } else {
      setSiteData({ ...siteData, ...{ loading: false } });
    }
  };
  const getFilterListing = async () => {
    const optionDefault = { label: "Tất cả", value: "all" };
    let optionCities = [optionDefault];
    let optionStatus = [optionDefault];
    const resCity = await api.getCity();
    const resUser = await api.getUserListing();
    const resStatus = await api.getStatusListing(userBrand?.brand_id);
    if (resStatus?.result) {
      resStatus?.result?.forEach((item: any) => {
        if (item?.code !== "rejected" && item?.code !== "completed") {
          optionStatus.push({
            value: item?.id,
            label: item?.name,
          });
        }
      });
      setStatusOptions(optionStatus);
    }
    if (resUser?.result) {
      const normalizedUsers = resUser?.result.map((user: any) => {
        return {
          value: user.id,
          label: `${user.first_name} ${user.last_name}`,
        };
      });
      setUsers(normalizedUsers);
    }
    if (resCity?.result) {
      resCity?.result?.forEach((item: any) => {
        optionCities.push({
          value: item?.id,
          label: item?.name,
        });
      });
      setCityOptions(optionCities);
    }
  };
  useEffect(() => {
    if (userBrand) getFilterListing();
  }, [userBrand]);
  useEffect(() => {
    getSiteListing();
  }, [
    siteData.page,
    siteData.searchCity,
    siteData.searchAssignee,
    status,
    siteData.searchInternalCode,
  ]);
  const onFiltered = (index: number, isFiltered: boolean) => {
    const row = siteData.tableMapping?.[index];
    const newTableMapping = siteData.tableMapping.map((sm, idx) => {
      if (index == idx) return { ...sm, isFiltered };
      if (sm.isFiltered != null) return { ...sm, isFiltered: false };
      return sm;
    });
    if (!row?.filterKey) return;
    getSiteListing(newTableMapping);
  };
  const onPageChange = (page: number) => {
    setSiteData({
      ...siteData,
      page,
    });
  };
  const onSearch = _.debounce((data: any) => {
    if (!status) {
      onChangeStatus("all");
    }
    getSiteListing(undefined, data);
  }, 500);
  const onFilterData = (type: string, data: any) => {
    if (type == "status") {
      onChangeStatus(data?.[0]?.value);
      return;
    }
    let newSiteData = siteData;
    if (type == "search") {
      onSearch(data);
    } else if (type == "city") {
      newSiteData = { ...newSiteData, searchCity: data };
    } else if (type == "user") {
      newSiteData = { ...newSiteData, searchAssignee: data?.[0]?.value };
    } else if (type == "internal_code") {
      if (!status && data) {
        onChangeStatus("all");
      }
      newSiteData = { ...newSiteData, searchInternalCode: data };
    }
    setSiteData(newSiteData);
  };
  const onApply = (data: Array<FilterField>) => {
    const columns = data.filter((el) => el.isActive).map((el) => el.label);
    api.updateUserPreference("site_column_show", columns);
    const newSiteData = {
      ...siteData,
      tableMapping: siteData.tableMapping.map((dt) => ({
        ...dt,
        isActive: data.find((d) => d.label == dt.label)?.isActive || false,
      })),
    };
    setSiteData(newSiteData);
  };
  const toggleCreateNewModal = () => {
    setCreateNewModal(!showCreateNewModal);
  };
  if (!status) {
    const renderStatisticItem = (item: SiteStatistic) => {
      const handleClick = () => {
        history.replace(`/sitev2?statistic=${item.id}`);
      };
      return (
        <SiteStatisticItem key={item.id} item={item} onClick={handleClick} />
      );
    };
    return (
      <div className="site-manager">
        <SiteListingFilter
          normalize
          dataStatus={statusOptions}
          dataUser={users}
          dataCities={cityOptions}
          onFilter={onFilterData}
          tableMapping={siteData.tableMapping}
          onApply={onApply}
          onCreateSite={toggleCreateNewModal}
          currentStatus={status}
        />
        <Row xs="1" sm="2" md="4">
          {siteStatistic?.map(renderStatisticItem)}
        </Row>
        <CreateNewSiteModal
          isShow={showCreateNewModal}
          toggleFunction={toggleCreateNewModal}
        />
      </div>
    );
  }
  return (
    <div className="site-listing-container">
      <SiteListingFilter
        currentStatus={status}
        dataStatus={statusOptions}
        dataUser={users}
        dataCities={cityOptions}
        onFilter={onFilterData}
        tableMapping={siteData.tableMapping}
        onApply={onApply}
        onCreateSite={toggleCreateNewModal}
      />
      {(siteData.loading && <Loading />) || (
        <SiteListingTable
          onRowClick={onSiteClick}
          sites={siteData.sites}
          tableMapping={siteData.tableMapping}
          onFiltered={onFiltered}
        />
      )}
      <SiteListingPagination
        totalPage={siteData.totalPage}
        onChange={onPageChange}
      />
      <CreateNewSiteModal
        isShow={showCreateNewModal}
        toggleFunction={toggleCreateNewModal}
      />
    </div>
  );
};

export default SiteListing;
